import React from "react";
import Styled from "styled-components";
import Image from "../asset/pic1.jpg";
function ImageCont() {
  return (
    <MainCont>
      <Img src={Image} alt="pic" />
    </MainCont>
  );
}
const MainCont = Styled.div`
overflow:hidden;
  height:88vh;
  box-shadow:0 0 8px 1px #262524;
  width:33vw;
  margin:2rem;
  position:relative;
  border-radius:35px;
  background:black;
  @media (max-width:768px){
    height:300px;
    width:300px;
    margin:0 0 1rem 0;
    border-radius:100%;
  }
`;
const Img = Styled.img`
  width:inherit;
  height:inherit;
  position:relative;
`;
export default ImageCont;
